<template>
<Layout>
    <div class="home-page-80-width  py-5">
        <header class="pb-3 mb-4 border-bottom">
            <h1 class=" fw-semibold  text-dark text-center" style="font-size: 2.5rem;">
               Panier
            </h1>
        </header>
  
        <!-- Empty cart -->
        <div v-if="!cartItems.length" class="text-center py-5">
            <div class="mb-4">
                <h3 class="mb-3">Vous n'avez aucun article dans votre panier</h3>
                <h2 class=" text-primary font-weight-bold text-center pt-3 banner-title-white" style="font-size:1.2rem !important;">
                    {{ $t('default.bannerSubTitle1') }} {{ $t('default.bannerSubTitle2') }}
                </h2>            
            </div>
            <a href="/demarrer-experience">
            <button class="btn font-weight-bold text-uppercase font-size-14 p-3 btn-primary" style="letter-spacing: 0.2px;margin:auto;" >Commencer vos achats</button>
            </a>
        </div>
  
        <div v-else class="row">
            <div class=" col-md-8  pr-md-3  text-dark">
                <div class="card mb-4 box-hovered mt-md-0 w-100 h-100">
                    <h2 class="card-header bg-white text-dark text-left mt-3 mb-2">       
                        <img height="42px" :src="require('@/assets/icons/cart.svg')" />
                         <span class="badge badge-white font-weight-bold font-size-16 "> {{ cart && cart.lines && cart.lines.total ?  cartItems.length +' Article(s)' : '' }}</span>
                    </h2>
                    <div class="card-body">
                        <div class="text-dark">
                            <div v-for="(item, index) in cartItems" :key="index" class="card mb-3 p-2 item-card">
                                <div class="d-flex">
                                    <img v-bind:src="'/api/image/get/product/small/' + item.variants[0].images[0]"
                                        alt="Product"
                                        class="me-3 cart-product-image" :class="{'grayed-out': !item.isAlreadyPersonalised}"/>

                                    <div class="flex-grow-1 ml-2">
                                        <div class="d-flex justify-content-between text-dark mb-2">
                                            <div >
                                                <div class="d-flex">
                                                    <h6 :class="{'grayed-out': !item.isAlreadyPersonalised}" class="mb-1 mt-1 text-dark">{{ item.title }}  </h6>
                                                    <img class="mt-0 ml-2"
                                                        height="20"
                                                        :src="require('@/assets/icons/trash.svg')"
                                                        @click="openDeleteModal(item)"
                                                        style="cursor: pointer;"
                                                    />
                                                </div>
                                                <small class="text-muted font-size-16" :class="{'grayed-out': !item.isAlreadyPersonalised}"> {{ item.variants[0].title }}</small>
                                                <div :class="{'grayed-out': !item.isAlreadyPersonalised}"><span class="badge badge-light font-weight-bold">{{ item.paperTypeLabel }}</span></div>
                                            </div>
                                            <div class="text-right d-flex">
                                                <div v-if="!item.isAlreadyPersonalised" class="mt-0">
                                                    <a :href="'/personnalisation-produit/' + item.bagDesignCode">
                                                        <b-button variant="outline-primary" class="text-uppercase" size="sm" > {{ !item.isAlreadyPersonalised ? 'Personnaliser' : 'Ouvrir' }}  </b-button>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row align-items-center ">
                                            <div class="col-lg-3 col-sm-4 col-12 text-sm-left text-right" :class="{'grayed-out': !item.isAlreadyPersonalised}"><span class="d-sm-none">{{ item.variants[0].cartItemQuantity }} x </span>{{ item.variants[0].priceAsString }}</div>
                                            <div class="col-lg-3 col-sm-4 col-6  mt-md-0 mt-2 text-md-center text-left mx-auto d-sm-block d-none">
                                                <div class="flex items-center  overflow-hidden rounded-lg mx-lg-auto" style=" max-width: 110px; border:1px solid #ddd; border-top:1px solid #ddd;">
                                                    <input
                                                        :ref="'quantityInput01_' + item.variants[0].id"
                                                        class="quantity-input w-20 text-center py-2 outline-none text-dark font-weight-bold    "
                                                        type="number"
                                                        :key="currentQuantityindex"
                                                        :value="item.variants[0].cartItemQuantity"
                                                        :min="item.variants[0].minQuantityOrdered"
                                                        @keyup.enter="updateQuantity(item.variants[0] ,  $event.target.value)"
                                                    />
                                                    <b-button variant="light"   class="pr-1 pl-1 float-right"  @click="updateQuantity(item.variants[0] , $refs['quantityInput01_' + item.variants[0].id][0].value)" style="border-radius:0px">
                                                        <img :src="require('@/assets/icons/cart-valid.svg')" alt="save" class="save-svg" />
                                                    </b-button>
                                                </div>
                                            </div>
                                            <strong class="col-lg-3 col-sm-4 col-12 mt-md-0 mt-2 font-size-16 text-sm-left text-right" :class="{'grayed-out': !item.isAlreadyPersonalised}">{{ item.variants[0].cartItemSubTotal }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="hasNonPersonalisedItem" class="text-danger font-weight-bold "> 
                                Tous les produits doivent être personnalisés!
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Order Summary - right column -->
            <div class="col-md-4 mt-3 mt-md-0">
                <div class="card mb-4 position-sticky w-100 h-100" style="top: 2rem;">
                    <div class="card-header bg-white mt-3 mb-3">
                        <h2 class="mb-0 fw-semibold text-dark">Panier</h2>
                    </div>
                    <div class="card-body  text-dark">
                        <!-- Subtotal -->
                        <div class="d-flex justify-content-between mb-3">
                            <span>Sous Total</span>
                            <span>{{ cart.lines.cartSubTotal }}</span>
                        </div>
                        <div class="fields">

                            <div class="shippingOptions">
                                <div v-for="(deliveryMode, index) in deliveryModes" :key="index"  
                                    @click="selectDeliveryMode(deliveryMode)"
                                    :class=" isDeliverySelected(deliveryMode) ? 'elementsradioButtonFieldSelected' : 'elementsradioButtonField'">                                
                                    <div class="titleamount">
                                        <div class="radioButton1">
                                            <div class="freeShipping text-dark">{{ deliveryMode.name }}</div>
                                            <b-spinner v-if="isCartLoading && selectedDeliveryMode && selectedDeliveryMode.id == deliveryMode.id" 
                                                variant="dark" small class="mr-2" ></b-spinner>
                                        </div>
                                        <div class="div">{{ isDeliveryFree(deliveryMode)  ? 'Gratuit' :  (deliveryMode.costAsFloat != 0 )? ('+ ' + deliveryMode.cost) : deliveryMode.cost }}</div>
                                    </div>

                                </div>
                            </div>
                        </div>



                          <!-- Promo Code Form -->
                        <div class="card pt-3 pb-0 mt-2 shadow-sm">
                            <label for="promoCode" class="form-label mb-2">Ajoutez votre code PROMO pour une remise instantanée</label>
                                <div class="input-group">
                                    <input 
                                        style="border: 1px solid ;border-radius: 5px 0 0 5px;border-right: 0px;"
                                        id="promoCode"
                                        type="text" 
                                        class="form-control rounded-start" 
                                        placeholder="Code Promo" 
                                        v-model="promoCode"
                                    >
                                    <div @click="applyPromo"  class="btn btn-outline-secondary " style="border: 1px solid  ; border-radius:  0 5px 5px 0; ">{{ !this.cart.lines.giftCardAmount || !this.cart.lines.finalAmountToPay ? 'Ajouter' : 'Retirer'}}
                                </div>
                            </div>
                        </div>



                        <!-- Total -->
                        <div class="d-flex justify-content-between mt-5 pt-2 mb-3">
                            <span class="fw-semibold">Total</span>
                            <strong class="font-size-20 text-primary">{{ cart.lines.cartTotal }}</strong>
                        </div>
                        <hr  v-if="cart.giftCardCode">
                         <!-- Discount -->
                        <div v-if="cart.giftCardCode"  class="d-flex justify-content-between mb-3">
                            <span class="fw-semibold">{{ $t('giftCard.payment') }}</span>
                            <strong class="font-size-16">{{ cart.lines.giftCardAmount }}</strong>
                        </div>
                        <div v-if="cart.lines.finalAmountToPay"  class="d-flex justify-content-between mt-4 mb-3">
                            <span class="fw-semibold">Net à payer</span>
                            <strong class="font-size-20 text-primary">{{ cart.lines.finalAmountToPay }}</strong>
                        </div>

                     

                        <!-- Checkout Button -->
                        <div class="mt-3" v-if="cartItems.length !== 0">
                            <button 
                                class="btn btn-primary font-size-18 btn-lg w-100 text-uppercase font-weight-bold"  
                                style="  letter-spacing: 2px;font-weight: 500;"
                                type="submit"
                                @click="goToPaiement"
                                :disabled="cartItems.length === 0 || hasNonPersonalisedItem"
                            >Payer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <b-modal
        v-model="showDeleteModal"
        :title="'Confirmer la suppression - ' +  itemToDelete.title +' de type ' + (itemToDelete.variants  ? itemToDelete.variants[0].title  : '') "
        hide-footer
        centered
        title-class="text-dark"
        title-tag="h5"
        size="lg"
        header-close-variant="secondary"
        >
        <div class="text-center">
            <p>Êtes-vous sûr de vouloir supprimer <strong> {{ itemToDelete.title }}</strong> <span>de type </span><strong>{{ itemToDelete.variants  ? itemToDelete.variants[0].title  : ''}}</strong> de votre panier ?</p>
            
            <b-button variant="danger" class="mr-2" @click="confirmDelete">
                Supprimer
            </b-button>
            
            <b-button variant="secondary" @click="showDeleteModal = false">
            Annuler
            </b-button>
        </div>
    </b-modal>

</Layout>
</template>
  
  <script>
  import Layout from "../router/layouts/main.vue";
  import CartApi from "@/services/cart-api";
  
  export default {
    name: 'Cart',
    components: { Layout },
  
    data() {
      return {
        deliveryModes:[],
        isCartLoading: false,
        promoCode: null,
        showDeleteModal: false,
        itemToDelete: {},
        selectedDeliveryMode: null,
        currentQuantityindex: 0
      }
    },

    watch: {
        '$store.state.cart.giftCardCode'(newCode) {
            this.promoCode = newCode || '';
        }
    },
  
    computed: {
        hasNonPersonalisedItem(){
            return this.cart?.lines?.list?.some(line => line.isAlreadyPersonalised === false) === true;
        },
        cart() {
            return this.$store.state.cart;
        },
        cartItems() {
            return this.cart?.lines?.list || [];
        },
     
    },
    mounted() {
        this.getDeliveryModes();
        this.selectedDeliveryMode = this.cart ? this.cart.deliveryMode : null; 
    },
    created() {
      this.$store.dispatch('fetchCart');
    },
  
    methods: {
        updateQuantity(variant , newValue) {
            const quantity = parseInt(newValue, 10);
            if (variant && variant.id && !isNaN(quantity) && quantity>0) {
                const addQuantity = quantity - variant.cartItemQuantity
                if(addQuantity != 0){
                    this.$store.dispatch('addToCart', [{ itemVariantId: variant.id, quantity: addQuantity }]).finally(()=>{
                        this.currentQuantityindex++
                    })
                }
            }
        },
        getDeliveryModes() {
            CartApi.getDeliveryModes().then(
                (deliveryModes)=> {
                this.deliveryModes = deliveryModes;
                }
            ).finally(() => {
                
            });
        },
        applyPromo() {
            let action;
            if(!this.cart.lines.giftCardAmount || !this.cart.lines.finalAmountToPay){
                action=1
            }else{
                action=0;
                this.promoCode= null
            }
            const payload = {
                cartId: this.cart.cartId,
                giftCardCode: this.promoCode,
                action:action
            };
            CartApi.validationGiftCardCode(payload).then(() => {
                this.$store.dispatch('fetchCart');
            });
        },
    
        goToPaiement() {
            this.$router.push({ path: "/paiement" });

        },
        openDeleteModal(item) {
            this.itemToDelete = item;
            this.showDeleteModal = true;
        },
        confirmDelete() {
            this.remove(this.itemToDelete);
            this.showDeleteModal = false;
        },
        remove(item) {
            this.$store.dispatch('removeFromCart', item.variants[0].id);
        },
        selectDeliveryMode(deliveryMode) {

            if (!deliveryMode) {
                return;
            }

            this.selectedDeliveryMode = deliveryMode;

            this.isCartLoading = true;
            this.$store.dispatch('setDeliveryModeToCart', this.selectedDeliveryMode ? this.selectedDeliveryMode.id : null )
            .finally(() => {
                this.isCartLoading = false;
            });
        },

        isDeliverySelected(deliveryMode) {
            return this.cart && this.cart.deliveryMode && this.cart.deliveryMode.id == deliveryMode.id;
        },

        isDeliveryFree(deliveryMode) {
            return this.cart && this.cart.lines && this.cart.lines.cartSubTotalAsFloat && deliveryMode.deliveryFreeThreshold != null
                ? this.cart.lines.cartSubTotalAsFloat >= deliveryMode.deliveryFreeThreshold 
                : false;
        },
  
    }
  };
  </script>
<style scoped>
.grayed-out {
    opacity: 0.5;
    filter: grayscale(100%);
}

.box-hovered{
    border: 1px solid #cbcbcb;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    border-radius:5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);

}



.quantity-control {
  display: flex;
  align-items: center;
  background-color: #fff;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  padding: 0 8px;
  height: 36px;
  min-width: 110px;
}

.icon-btn {
  width: 21px;
  height: 19px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.icon-btn:hover {
  transform: scale(1.2);
}

.cart-product-image{
    width: 100%;
    max-width: 100px;
    height: auto;
    object-fit: cover; 
    border-radius: 4px;
}
@media (max-width : 576px) {
    .cart-product-image{
        width: 65px; 
        height: 75px; 
        object-fit: cover; 
        border-radius: 4px;
    }
}
.quantity-input {
  width: 70px;
  text-align: center;
  border: none;
  font-weight: 600;
  font-size: 14px;
  background: transparent;
  outline: none;
}

.quantity-input::-webkit-inner-spin-button,
.quantity-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.item-card{
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    border-bottom: 1px solid #ddd;
    
}

.shippingOptions {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 0px 16px;
    gap: 12px;
}
.titleamount {
    flex: 1;
    position: relative;
    height: 26px;
}
.freeShipping {
    position: relative;
    line-height: 26px;
}
.fields {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 0px 0px 10px;
}
.elementsradioButtonFieldSelected {
    align-self: stretch;
    border-radius: 4px;
    background-color: #dddddd93;
    border: 1px solid #121212;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 13px 16px;
    cursor: pointer;
    font-weight:900;
}

.elementsradioButtonField {
    align-self: stretch;
    border-radius: 4px;
    background-color: #fff;
    border: 1px solid #cbcbcb;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 13px 16px;
    cursor: pointer;
}
.div {
    position: absolute;
    top: calc(50% - 13px);
    right: 0px;
    line-height: 26px;
    text-align: right;
}
.radioButton1 {
    position: absolute;
    top: calc(50% - 13px);
    left: 0px;
    display: flex !important;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
}

.save-svg {
  width: 20px;
  height: 20px;
}


</style>